module.exports = __webpack_public_path__ + "2a3eba1136c018d92c62db7d99d4f05b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-14.jpg
// module id = 1154
// module chunks = 0